var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.53033 15.5908C0.237437 15.2979 0.237437 14.823 0.53033 14.5301L14.5301 0.53031C14.823 0.237418 15.2979 0.237417 15.5908 0.53031C15.8837 0.823204 15.8837 1.29808 15.5908 1.59097L1.59099 15.5908C1.2981 15.8836 0.823223 15.8836 0.53033 15.5908Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.591 15.5908C15.2981 15.8837 14.8232 15.8837 14.5303 15.5908L0.530555 1.59098C0.237662 1.29809 0.237661 0.823213 0.530555 0.530319C0.823448 0.237426 1.29832 0.237426 1.59121 0.530319L15.591 14.5301C15.8839 14.823 15.8839 15.2979 15.591 15.5908Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.c8aada62edd74f469cac936932768756.svg";
export { ForwardRef as ReactComponent };